// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

export const CatalogueEngagementRingInputFragmentDoc = `
    fragment catalogueEngagementRingInput on CatalogueEngagementRing {
  catalogueCode
  centreStoneConstraints {
    shape {
      systemCode
    }
  }
  slug
  primaryMetal {
    systemCode
  }
  suffixSlug
}
    `;